import { AxiosResponse } from 'axios';

export interface ApiResponse<T> {
  data?: T;
  error?: ErrorResponse;
}

interface ErrorResponse {
  message: string;
  code: number;
}

export const handleRequest = async <T>(
  requestFunction: () => Promise<AxiosResponse<T>>,
): Promise<ApiResponse<T>> => {
  try {
    const response = await requestFunction();
    return { data: response.data };
  } catch (error: any) {
    return {
      error: { message: error.response?.data?.message || error.message, code: error.status },
    };
  }
};
